import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './Auth/AuthContext';
import Home from './Home';
import Dashboard from './components/Dashboard';
import GetPrintQuote from './components/GetPrintQuote';
import './css/App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/GetPrintQuote" element={<GetPrintQuote />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
